<template>
  <div>
    <search-bar
      @search="onSearch"
      name="sa_custname,sa_seller,pr_code,pr_detail,pr_spec,pr_orispeccode"
      placeholder="输入客户、业务员、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sa_code + item.sd_detno"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.sa_custname }}</p>
          <p>{{ item.sa_code }} #{{ item.sd_detno }}</p>
          <p class="list-item-muted">{{ item.pr_detail }}</p>
          <p class="list-item-muted">
            <span  v-if="item.pr_orispeccode">{{ item.pr_orispeccode }}/</span>
            <span  v-if="item.pr_spec">{{ item.pr_spec }}</span>
          </p>
          <p class="list-item-muted"></p>
        </div>
        <div class="weui-cell__ft">
          <span v-format="'#,##0.#'">￥{{ item.sd_total }}</span>
          <p>
            <span v-format="'#,##0.#'">{{ item.sd_qty }}</span>
            &nbsp;{{ item.pr_unit }}
          </p>
          <p class="list-item-muted" v-if="item.sd_pdsendqty">
            已出&nbsp;
            <span v-format="'#,##0.#'">{{ item.sd_pdsendqty }}</span>
            &nbsp;{{ item.pr_unit }}
          </p>
          <span v-else class="list-item-status warning">未出库</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{
        getTotal("sd_total")
      }}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/report/saleDetail",
      filters: [
        {
          type: "date",
          name: "sd_delivery",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "已出库",
              condition: "sa_sendstatuscode='TURNOUT'",
            },
            {
              value: 2,
              label: "未出库",
              condition: "sa_sendstatuscode='UNTURNOUT'",
            },
            {
              value: 3,
              label: "部分出库",
              condition: "sa_sendstatuscode='PARTOUT'",
            },
            {
              value: 4,
              label: "已关闭",
              condition: "sa_sendstatuscode='CLOSE'",
            },
          ],
        },
      ],
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10,
      },
    };
  },
  mounted() {
    this.doSearch();
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "SaleOrderReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  },
  
};
</script>
<style scoped>
.weui-cell{
  align-items: flex-start !important;
}
</style>